import React, { FC } from "react";
import { Box, CircularProgress, makeStyles } from "@material-ui/core";
import { px } from "Configs/theme";

const LoadingIndicator: FC = () => {
	const classes = useStyles();

	return (
		<Box className={classes.box}>
			<CircularProgress />
		</Box>
	);
};

export default LoadingIndicator;

const useStyles = makeStyles({
	box: {
		padding: px.m,
		display: "flex",
		flex: 1,
		alignItems: "center",
		justifyContent: "center",
	},
});
